"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pixiFps = require("./app/pixi-fps");

var _default = _pixiFps.PixiFps;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6WyJQaXhpRnBzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O2VBRWVBLGdCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgUGl4aUZwcyB9IGZyb20gXCIuL2FwcC9waXhpLWZwc1wiO1xuXG5leHBvcnQgZGVmYXVsdCBQaXhpRnBzO1xuIl19